<template lang="pug">
  .solicitud-vacaciones

    .title
      span(v-if="isEditing").little Modificando la solicitud {{ solicitud.id }}
      span(v-else-if="isExcepcion").little Ingresa una solicitud de vacaciones sin validaciones
      span(v-else) Ingresa una solicitud de vacaciones

      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition-group.contenedor-datos(name="fade-smooth", tag="div")
      .indicaciones(v-if="mostrarIndicaciones", key="indicaciones")
        .title
          span Datos a tener en cuenta
          span.icon.close(
            @click="mostrarIndicaciones = false"
          )
            i.fa.fa-close
        ul.list
          //- li.list-item
          //-   span Debes tomar minimo
          //-   strong 7
          //-   span dias
          //- li.list-item Debes pedir tus vacaciones minimo con 15 dias de anticipacion
          li.list-item
            span La solicitud la debe aprobar&nbsp;
            strong
              i.fa.fa-spinner.fa-spin(v-if="isLoading")
              span(v-else) {{ jefe }}

      .indicaciones(v-if="empleadoExcepcion && empleadoExcepcion.codigo", key="indicaciones-excepcion")
        .title
          span Datos a tener en cuenta
        ul.list
          li.list-item
            span Ingresando una excepción para&nbsp;
            strong {{ empleadoExcepcion.nombre }}
          li.list-item
            span La solicitud la debe aprobar&nbsp;
            strong {{ empleadoExcepcion.nombreJefe }}
          li.list-item
            span Días por tomar&nbsp;
            strong  {{ empleadoExcepcion.diasReales }}
          li.list-item
            span Días por programar&nbsp;
            strong  {{ empleadoExcepcion.diasDisponibles }}
          li.list-item
            span La fecha de retorno debe ser&nbsp;
            strong después a hoy
            span , si no fuera el caso, por favor comunicarse con sistemas
          li.list-item
            span Le llegará un mail de notificación a {{ empleadoExcepcion.nombre }} para que&nbsp;
            strong envíe&nbsp;
            span la solicitud a su jefe

      .contenedor-transaccion(key="transaccion")
        .codigo-empleado(v-if="isExcepcion")
          .control
            p Codigo de empleado
            input.input(
              type="number",
              v-model="codigoEmpleado"
            )
            span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
              i.fa.fa-search
          transition(name="fade-quick")
            .pop-over(
                v-if="mostrarBusquedaEmpleado"
              )
                lookup-small-empleado(
                  @selected="seleccionarEmpleado"
                  @close="mostrarBusquedaEmpleado = false"
                  :codigo="codigoEmpleado"
                )
        .fechas
          .control
            p Desde
            input.input(type="date" v-model="desde" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}")
          .control
            p Hasta
            input.input(type="date", v-model="hasta", pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}")

        p
          span Retornarias el&nbsp;
          strong {{ retorno }}

        p
          span Te tomarias&nbsp;
          strong {{ dias }}
          span &nbsp;dias de vacaciones

        .acciones
          button.button(
            @click="guardar(false)"
            :class="{ 'is-loading': isSaving }"
          )
            span.icon.is-small
              i.fa.fa-save
            span Guardar
          button.button(
            @click="guardar(true)"
            :class="{ 'is-loading': isSaving }"
            v-if="!isExcepcion"
          )
            span.icon.is-small
              i.fa.fa-check
            span Guardar y Enviar
</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
export default {
  name: 'solicitud_vacaciones_component',
  components: {
    LookupSmallEmpleado
  },
  props: ['isEditing', 'solicitud', 'isExcepcion'],
  data () {
    return {
      desde               : '',
      hasta               : '',
      retorno             : '',
      dias                : 7,
      jefe                : '',
      mostrarIndicaciones : true,
      mostrarSolicitud    : true,
      mostrarBusquedaEmpleado: false,
      codigoEmpleado : '',
      empleadoExcepcion: {},
      isSaving: false,
      isLoading: false
    }
  },
  watch : {
    desde (value) {
      var startDate = window.moment(value, 'YYYY-MM-DD')
      var endDate = window.moment(this.hasta, 'YYYY-MM-DD')
      if (!startDate.isBefore(endDate) || endDate.diff(startDate, 'days') < 7) {
        this.hasta = startDate.add(6, 'days').format('YYYY-MM-DD')
      }
      this.calcularDiasYRetorno()
    },
    hasta (value) {
      this.calcularDiasYRetorno()
    }
  },
  created () {
    this.desde = window.moment().add(15, 'days').format('YYYY-MM-DD')
    this.hasta = window.moment().add(21, 'days').format('YYYY-MM-DD')
    if (this.isExcepcion) this.mostrarIndicaciones = false
    if (!this.isExcepcion) this.fetchInfoJefe()

    // Si viene editando muestro los datos de la solicitud
    if (this.isEditing) {
      this.desde = window.moment(this.solicitud.desde, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.hasta = window.moment(this.solicitud.hasta, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.dias  = this.solicitud.dias
      this.retorno = window.moment(this.solicitud.retorno, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }
  },
  methods: {
    calcularDiasYRetorno () {
      var startDate = window.moment(this.desde, 'YYYY-MM-DD')
      var endDate = window.moment(this.hasta, 'YYYY-MM-DD')
      this.dias = endDate.diff(startDate, 'days') + 1
      this.retorno = endDate.add(1, 'days').format('DD/MM/YYYY')
    },
    fetchInfoJefe () {
      var vm = this
      vm.isLoading = true
      var obj = {
      }

      apiGet(vm, '/vacaciones/empleado/jefe', obj, function (data) {
        vm.jefe = data.data.nombre
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardar (isSending) {
      var vm = this
      vm.isSaving = true

      var obj = {
        desde     : window.moment(vm.desde, 'YYYY-MM-DD').toDate(),
        hasta     : window.moment(vm.hasta, 'YYYY-MM-DD').toDate(),
        retorno   : window.moment(vm.retorno, 'DD/MM/YYYY').toDate(),
        dias      : vm.dias,
        isSending : isSending
      }

      if (vm.isEditing) {
        obj.id        = vm.solicitud.id
        obj.isEditing = vm.isEditing
      }

      if (vm.isExcepcion) {
        obj.isExcepcion = vm.isExcepcion
        obj.codigoEmpleado = vm.codigoEmpleado
      }

      apiPost(vm, '/vacaciones/solicitud', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        if (vm.isEditing) {
          vm.$emit('closeRefresh')
        } else {
          vm.$emit('successNew')
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    seleccionarEmpleado (o) {
      this.codigoEmpleado = o.codigo
      this.empleadoExcepcion = {}
      this.asignarEmpleadoExcepcion()
    },
    asignarEmpleadoExcepcion () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleadoExcepcion = data.data
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .solicitud-vacaciones
    .close
      position: absolute;
      top: 5px;
      right: 5px;
      cursor pointer
      i
        font-size 16px

    .title
      padding-right: 12px;
      padding-left: 12px;
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

    .contenedor-transaccion
      .fechas
        display flex
        justify-content center
        .control
          padding 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    position relative
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      position: absolute;
      top: 1px;
      right: 1px;
      cursor pointer
      i
        font-size 16px

    .title
      padding-right: 12px;
      padding-left: 12px;
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 42px;

  @media (max-width 673px)
    .contenedor-datos
      flex-direction: column;
    .indicaciones
      max-width: 100%;
</style>



// WEBPACK FOOTER //
// Component_Solicitud_Vacaciones.vue?1cbaa3d4